import { Location, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockDoor } from 'mocks/graphqlMocks/door';
import { generateMockLocation } from 'mocks/graphqlMocks/location';

export function mockedUpdateLocationWithDoorsData(updateLocation: Location): Pick<Mutation, 'updateLocation'> {
  return {
    updateLocation
  };
}

export const mockedUpdateLocationWithDoorsDataForMutation = mockedUpdateLocationWithDoorsData(
  generateMockLocation({ id: 'mockedLocationId0', name: 'mockedUpdatedLocationName' })
);

export const mockedUpdateDeviceGroupDataForMutation = mockedUpdateLocationWithDoorsData(
  generateMockLocation({
    id: 'TestGroup1',
    name: 'Test group 1',
    doors: [generateMockDoor({ id: 'mockedDoorId1', name: 'door 1' })]
  })
);
